
<div class="iframe-container" [ngClass]="{'hide-footer': whiteLabel}">
  <ng-container *ngIf="iframeURL">
    <iframe 
      [src]="iframeURL"
      frameborder="0" 
      (load)="hideSpinner()">
    </iframe>
  </ng-container>
</div>